<template>
  <teleport to="body">
    <div class="backplate">
      <div class="general-viewer">
        <div class="header-line">
          <div class="flex flex-row items-center gap-1">

            <UserAvatar withDayoffBadge :user='user' :isUser='true' noBorder />

            <div class="flex flex-col gap-1">
              <div class="username flex flex-row items-center gap-1">
                {{ user.username }}

                <span class="time flex flex-row gap-1 ml-2">
                  <Time :time='when' /> {{ $t('task.ago') }}
                </span>
              </div>
              <div class="filename">
                {{ props.filename }}
              </div>
            </div>

            
          </div>

          <div class="flex flex-row gap-4 items-center">
            <div class="file-item-download ml-2" @click="downloadFile">
              <i class="tr tr-download"></i>
            </div>
            <CloseButton @click="$emit('close')" />
          </div>
        </div>

        <div class="content">
          <slot></slot>
        </div>
        
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import UserAvatar from '@/components/elements/UserAvatar.vue';
import Time from '@/components/elements/Time.vue';
import CloseButton from '@/components/elements/CloseButton.vue';
import axios from 'axios';

const props = defineProps({
  url: {
    type: String,
    required: true,
  },
  filename: {
    type: String,
    required: true
  },
  user: {
    type: Object,
    required: true
  },
  when: {
    type: String,
    required: true
  }
});

const emitted = defineEmits(['close']);

async function downloadFile() {
   try {
    const response = await axios.get(props.url, { responseType: 'blob' });
    const blob = new Blob([response.data]);
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = props.filename;
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error(error);
  }
}

</script>

<style scoped lang="scss">

.general-viewer {
  width: 100%;
  height: 100%;
  background-color: var(--bg2);
  border-radius: 8px;
  box-shadow: var(--shadow-popover);
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 600px) {
    border-radius: 0;
  }

  .header-line {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 20px;
    background-color: var(--card-header);
    border-radius: 8px 8px 0 0;
    color: var(--card-text);
  }
    
}

.backplate {
  background-color: var(--backdrop);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  display: flex;
  padding: 40px;
  @media screen and (max-width: 600px) {
    padding: 0;
  }
}

.username {
  font-size: 16px;
  font-weight: bold;
  color: var(--text);

  .time {
    font-size: 14px;
    color: var(--text);
    filter: contrast(0.8);
    font-weight: normal;
  }
}

.filename {
  color: var(--text-muted);
}

.content {
  min-height: 0;
}

.file-item-download {
  cursor: pointer;
  color: var(--text);
  font-size: 26px;
  transition: color 0.3s;

  &:hover {
    opacity: 0.8;
  }

  i {
    pointer-events: none;
  }
}
</style>

